<template>
  <Card :bordered="false" class="response-message">
    <Icon type="md-close-circle" size="120" color="#ed4014" class="message-icon" />
    <h2>Password Reset Link Expired</h2><br>
    <h4>Reset password link has already expired. Please request another reset password link.</h4>
  </Card>
</template>
<script>

  export default {
    name: "PasswordExpiredLink",
    data() {
      return {
      };
    },
  };
</script>
<style scoped>
</style>
